import { ReactNode } from "react";
import { cn } from "@tellescope/design-system";
import { Label } from "@tellescope/ui";

export interface EditableFieldProps {
  id: string;
  label: string;
  required?: boolean;
  editing: boolean;
  canEdit: boolean;
  onStartEditing: () => void;
  displayValue?: string;
  placeholder: string;
  error?: string;
  children: ReactNode;
}

// TODO: replace this click-to-edit read-only display + label scaffold with an abstracted
//   design-system field/read-only-field component once one exists.
export const EditableField = ({
  id,
  label,
  required,
  editing,
  canEdit,
  onStartEditing,
  displayValue,
  placeholder,
  error,
  children,
}: EditableFieldProps) => (
  <div className="space-y-1">
    <Label htmlFor={id} required={required} className="text-left break-words">
      {label}
    </Label>
    {editing ? (
      <>
        {children}
        {error && <p className="text-xs text-destructive font-light">{error}</p>}
      </>
    ) : canEdit ? (
      <button
        type="button"
        id={id}
        onClick={onStartEditing}
        className={cn(
          "min-h-9 w-full flex items-center py-2 text-sm font-light text-left whitespace-pre-wrap break-words rounded-sm transition-all hover:bg-secondary px-2 -mx-2 cursor-text",
          displayValue ? "text-foreground" : "text-muted-foreground/60 italic"
        )}
      >
        {displayValue || placeholder}
      </button>
    ) : (
      <p
        id={id}
        className={cn(
          "min-h-9 flex items-center py-2 text-sm font-light whitespace-pre-wrap break-words select-text",
          displayValue ? "text-foreground" : "text-muted-foreground/60 italic"
        )}
      >
        {displayValue || placeholder}
      </p>
    )}
  </div>
);
